import React from 'react'
import { useHistory } from 'react-router'

import ResultsTemplate from '@new/__global/components/OmniSearch/components/ResultTemplates/ResultsTemplate'
import { ViewModeTypes } from '@new/domains/properties/screens/viewMode/ViewMode.types'

import {
  IPropertiesResultsProps,
  OmniSearchHome,
} from '@/_new/__global/components/OmniSearch/OmniSearch.types'
import { mountRouteUrl, ROUTES } from '@routes'

import { PropertiesDetail } from './PropertiesDetail'

function PropertiesResults({
  activeIndex,
  enabledNavigation,
  homes,
  setIndex,
  searchTerm,
  totalCount,
}: IPropertiesResultsProps): JSX.Element {
  const history = useHistory()

  const onClick = (it: OmniSearchHome) => {
    history.push(
      mountRouteUrl(ROUTES.propertyInfo.path, {
        id: it.id,
        section: 'basic-info',
        viewMode: 'read',
      }),
    )
  }

  return (
    <ResultsTemplate
      data={homes}
      titlePrefix={homes.length === 1 ? 'property' : 'properties'}
      onClick={onClick}
      activeIndex={activeIndex}
      setIndex={setIndex}
      baseUrl={`${ROUTES.properties.path}/${ViewModeTypes.FINANCE}`}
      queryParamKey="name"
      searchTerm={searchTerm}
      totalCount={totalCount}
      enabledNavigation={enabledNavigation}
      renderChildren={(it: OmniSearchHome) => (
        <PropertiesDetail
          id={it.id}
          name={it.name}
          thumbnail={it.thumbnail?.url ?? ''}
          region={it.region?.name ?? ''}
        />
      )}
    />
  )
}

export default PropertiesResults
